var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    [
      _c(
        "b-nav",
        { attrs: { vertical: "" } },
        [
          _c("b-nav-text", { staticClass: "text-uppercase text-muted" }, [
            _vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/dashboard" } }, [
            _c("i", { staticClass: "noOutline ti-dashboard mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.appSidebar.navItem.dashboard")))
            ])
          ]),
          _vm._v(" "),
          _vm.isPolicyHolder
            ? _c("b-nav-item", { attrs: { to: "/contracts" } }, [
                _c("i", { staticClass: "noOutline ti-receipt mx-2" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("message.appSidebar.navItem.contracts")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isPolicyHolder
            ? _c("b-nav-item", { attrs: { to: "/contactpersons" } }, [
                _c("i", { staticClass: "noOutline ti-user mx-2" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("message.appSidebar.navItem.contactPersons"))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/addresses" } }, [
            _c("i", { staticClass: "noOutline ti-home mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.appSidebar.navItem.addresses")))
            ])
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/faq" } }, [
            _c("i", { staticClass: "noOutline ti-help mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.appSidebar.navItem.faq")))
            ])
          ]),
          _vm._v(" "),
          _c("b-nav-item", { attrs: { to: "/account" } }, [
            _c("i", { staticClass: "noOutline ti-settings mx-2" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.appSidebar.navItem.account")))
            ])
          ]),
          _vm._v(" "),
          _vm.isContactPerson && _vm.policyHolders.length > 0
            ? _c(
                "div",
                [
                  _c("hr"),
                  _vm._v(" "),
                  _c("b-nav-text", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("message.appSidebar.navItem.contactPersonOf")
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.policyHolders, function(policyHolder) {
                    return _c(
                      "b-nav-item",
                      {
                        key: policyHolder.id,
                        attrs: { to: "/policyHolders/" + policyHolder.id }
                      },
                      [
                        !policyHolder.dateOfDeath
                          ? _c("i", { staticClass: "ti-user mx-2" })
                          : _vm._e(),
                        _vm._v(" "),
                        policyHolder.dateOfDeath
                          ? _c("img", {
                              staticClass: "cross mx-2",
                              attrs: {
                                src: require("@/assets/cross.png"),
                                width: "16"
                              }
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              policyHolder.firstName +
                                " " +
                                policyHolder.lastName
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bf4ad5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf4ad5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppSidebar.vue
// module id = K9wL
// module chunks = 1